import { StyleSheet, Dimensions } from 'react-native';

const { width } = Dimensions.get('window');

export const createStyles = (theme: 'light' | 'dark' = 'light', backgroundColor?: string) => {
  // 基础颜色配置
  const c = {
    background: backgroundColor ?? (theme === 'light' ? '#fff' : '#000'),
    border: theme === 'light' ? '#e0e0e0' : '#333',
    primary: '#007AFF',
    subText: theme === 'light' ? '#999' : '#666',
  };

  return StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: backgroundColor ?? c.background,
    },
    contentContainer: {
      flexGrow: 1,
      backgroundColor: backgroundColor ?? c.background,
    },
    contentContainerFull: {
      flex: 1,
    },
    // 空状态
    emptyContainer: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      paddingVertical: 60,
    },
    emptyIcon: {
      width: 120,
      height: 120,
      marginBottom: 16,
    },
    emptyText: {
      fontSize: 14,
      color: c.subText,
    },
    // 加载中
    loadingContainer: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      paddingVertical: 60,
    },
    loadingText: {
      fontSize: 14,
      color: c.subText,
      marginTop: 12,
    },
    // 加载更多
    loadMoreContainer: {
      paddingVertical: 16,
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'row',
    },
    loadMoreText: {
      fontSize: 13,
      color: c.subText,
      marginLeft: 8,
    },
    // 没有更多
    noMoreContainer: {
      paddingVertical: 16,
      alignItems: 'center',
      justifyContent: 'center',
    },
    noMoreText: {
      fontSize: 13,
      color: c.subText,
    },
    noMoreLine: {
      width: 40,
      height: 1,
      backgroundColor: c.border,
      marginHorizontal: 12,
    },
    noMoreContent: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    // 错误状态
    errorContainer: {
      flex: 1,
      minHeight: 300,
      alignItems: 'center',
      justifyContent: 'center',
    },
    errorText: {
      fontSize: 13,
      color: c.subText,
      marginBottom: 12,
    },
    retryButton: {
      paddingHorizontal: 20,
      paddingVertical: 8,
      backgroundColor: c.primary,
      borderRadius: 16,
    },
    retryText: {
      fontSize: 14,
      color: '#fff',
    },
    // 返回顶部按钮
    scrollToTopButton: {
      position: 'absolute',
      right: 16,
      bottom: 16,
      width: 40,
      height: 40,
      borderRadius: 20,
      backgroundColor: 'rgba(0,0,0,0.6)',
      alignItems: 'center',
      justifyContent: 'center',
    },
    scrollToTopIcon: {
      fontSize: 20,
      color: '#fff',
    },
    // 分隔线
    separator: {
      height: 8,
    },
    // 骨架屏
    skeletonItem: {
      padding: 16,
      backgroundColor: backgroundColor ?? c.background,
    },
    skeletonRow: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    skeletonAvatar: {
      width: 48,
      height: 48,
      borderRadius: 24,
      backgroundColor: c.border,
    },
    skeletonContent: {
      flex: 1,
      marginLeft: 12,
    },
    skeletonTitle: {
      height: 16,
      width: width * 0.6,
      backgroundColor: c.border,
      borderRadius: 4,
      marginBottom: 8,
    },
    skeletonDesc: {
      height: 12,
      width: width * 0.4,
      backgroundColor: c.border,
      borderRadius: 4,
    },
    // 懒加载占位
    lazyPlaceholder: {
      backgroundColor: c.border,
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden',
    },
    lazyPlaceholderShimmer: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },
  });
};

export default createStyles;
